const DUMMY_SUB_PATH = '';

export function getBaseURL(): string {
  return `${window.location.origin}${DUMMY_SUB_PATH}`;
}
